export class IxCardTestIds {
  public static ACCOUNT = (id: string) => `ix-card-account-${id}`;

  public static ROLE = (id: string) => `ix-card-role-${id}`;
}
